import React, { useState } from 'react';
import { HiPlus } from 'react-icons/hi';
import { FiTrendingUp } from 'react-icons/fi';
import {
  IoFlameOutline,
  IoTimeOutline,
  IoCheckmarkCircleOutline,
  IoWarningOutline,
} from 'react-icons/io5';
import IncidentSelection from './IncidentSelection';

export default function IncidentManagementHeader() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const stats = [
    {
      id: 'open',
      title: 'Open',
      value: '8',
      desc: 'Require attention',
      icon: IoFlameOutline,
      bgColor: 'bg-rose-50',
      iconColor: 'text-rose-500',
    },
    {
      id: 'progress',
      title: 'In Progress',
      value: '5',
      desc: 'Being resolved',
      icon: IoTimeOutline,
      bgColor: 'bg-amber-50',
      iconColor: 'text-amber-500',
    },
    {
      id: 'resolved',
      title: 'Resolved',
      value: '34',
      desc: 'Closed incidents',
      icon: IoCheckmarkCircleOutline,
      bgColor: 'bg-emerald-50',
      iconColor: 'text-emerald-500',
    },
    {
      id: 'overdue',
      title: 'Overdue',
      value: '2',
      desc: 'Past due resolution',
      icon: IoWarningOutline,
      bgColor: 'bg-red-50',
      iconColor: 'text-red-500',
    },
  ];

  return (
    <div className="w-full rounded-3xl border border-gray-100/80 bg-gray-50/50 p-4 font-sans sm:p-5 lg:p-6">

      {/* Header */}
      <header className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <h1 className="text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
            Incident Management
          </h1>
          <p className="mt-1 max-w-2xl text-xs font-normal leading-5 text-gray-500 sm:text-sm">
            Report, track and resolve all incidents across your restaurant.
          </p>
        </div>

        <div className="w-full sm:w-auto">
          <button
            type="button"
            onClick={() => setIsModalOpen(true)}
            className="flex w-full items-center justify-center gap-1.5 rounded-xl bg-blue-600 px-4 py-2.5 text-xs font-bold text-white shadow-sm transition-colors hover:bg-blue-700 sm:w-auto"
          >
            <HiPlus className="h-4 w-4" />
            <span>New Incident</span>
          </button>
        </div>
      </header>

      {/* Metrics */}
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-2 lg:grid-cols-5 lg:gap-4">
        {stats.map((card) => {
          const IconComponent = card.icon;

          return (
            <div
              key={card.id}
              className="flex min-h-[120px] flex-col justify-between rounded-2xl border border-gray-100 bg-white p-3 shadow-sm sm:p-5"
            >
              <div className="flex items-center gap-2 sm:gap-3">
                <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg sm:h-9 sm:w-9 ${card.bgColor} ${card.iconColor}`}>
                  <IconComponent className="h-4 w-4 stroke-[2.5] sm:h-5 sm:w-5" />
                </div>

                <span className="text-[11px] font-bold tracking-tight text-gray-900 sm:text-xs">
                  {card.title}
                </span>
              </div>

              <div className="mt-3">
                <span className="block text-2xl font-bold leading-none text-gray-900 sm:text-[26px]">
                  {card.value}
                </span>

                <span className="mt-1.5 block text-[10px] font-medium text-gray-400 sm:text-[11px]">
                  {card.desc}
                </span>
              </div>
            </div>
          );
        })}

        {/* This Month */}
        <div className="flex min-h-[120px] flex-col justify-between rounded-2xl border border-gray-100 bg-white p-3 shadow-sm sm:p-5">
          <div>
            <span className="block text-[11px] font-bold tracking-tight text-gray-900 sm:text-xs">
              This Month
            </span>
          </div>

          <div className="mt-3">
            <span className="block text-2xl font-bold leading-none text-gray-900 sm:text-[26px]">
              15
            </span>

            <span className="mt-1 block text-[10px] font-medium text-gray-400 sm:text-[11px]">
              Total incidents
            </span>

            <div className="mt-1 flex items-center gap-1 text-[9px] font-bold text-emerald-600 sm:text-[10px]">
              <FiTrendingUp className="h-3 w-3 shrink-0 sm:h-3.5 sm:w-3.5" />
              <span>6% vs last month</span>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-2 backdrop-blur-sm sm:p-4">
          {/* Backdrop */}
          <button
            type="button"
            aria-label="Close modal"
            onClick={() => setIsModalOpen(false)}
            className="absolute inset-0 h-full w-full cursor-default"
          />

          {/* Modal Container */}
          <div className="relative z-10 flex max-h-[95vh] w-full max-w-4xl flex-col overflow-hidden rounded-xl bg-white shadow-2xl sm:max-h-[90vh] sm:rounded-2xl">
            <div className="min-h-0 flex-1 overflow-y-auto">
              <IncidentSelection onClose={() => setIsModalOpen(false)} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}